import { FC } from 'react'
import cn from 'classnames'

import { IMessage } from '@/context/types'

import './styles.css'

interface ImageTypeProps {
  message: IMessage
}

const ImageType: FC<ImageTypeProps> = ({ message }) => {
  return (
    <div className="pmui-py-2">
      <div
        className={cn(
          'pmui-mr-4 pmui-bg-pop-gray-50 pmui-w-56 pmui-h-fit pmui-rounded-xl pmui-flex-shrink-0',
          'pmui-cursor-pointer',
        )}
      >
        <img
          src={message.content.mediaUrl}
          className="pmui-object-cover pmui-w-full pmui-h-32 pmui-rounded-tl-xl pmui-rounded-tr-xl"
        />
        <div className="pmui-p-4 pmui-text-sm pmui-font-semibold ">
          {message.content.text}
        </div>
      </div>
    </div>
  )
}

export default ImageType
